function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), React.createElement("g", {
  fill: "none"
}, React.createElement("path", {
  fill: "#87BBFD",
  d: "M23.93 10.74l-.94.94-4.14 4.14a7.5 7.5 0 01-10.6 0L1.41 9l-.8-.8A11.98 11.98 0 0012 24a12 12 0 0011.93-13.26"
}), React.createElement("path", {
  fill: "#555ABF",
  d: "M14.72 9.82a7.5 7.5 0 01-10.6 0l-1.7-1.7a1 1 0 01-.19-1.17A11 11 0 0119.3 3.77a1 1 0 01.03 1.45l-4.6 4.6zm6.03-6.03A12 12 0 00.62 8.2l.8.81 6.82 6.82a7.5 7.5 0 0010.6 0L23 11.68l.94-.94a11.95 11.95 0 00-3.18-6.95z"
}), React.createElement("path", {
  fill: "#FFF",
  d: "M12 1a11 11 0 00-9.77 5.95 1 1 0 00.18 1.17l1.7 1.7a7.5 7.5 0 0010.61 0l4.6-4.6a1 1 0 00-.02-1.44A10.95 10.95 0 0012 1"
}))));